var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTitleBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 363.319,
    height: 90.949,
    viewBox: "0 0 363.319 90.949",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0.12;}.b{fill:#54240f;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-4.9,6.8c2-2.716,7.138-2.549,7.138-2.549L76.079,0l8.8,4.9V0H276.853l3.524,4.9L284.928,0l63.286-1.67s5.44-.218,6.456.435,3.2,1.69,2.4,5.912c-2.689,14.273-18.689,61.569-18.689,61.569l-4.993,7.227L269,75l-13.139-5.922V75H87.386l-6.827-5.922L78.171,75s-63.924-.374-65.158-1.317S6.117,70.85-5.744,15.115C-5.744,15.115-6.9,9.518-4.9,6.8Z",
    transform: "translate(6.075 8.705)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-731.239,281.72l-8.739,16.524L-740.356,284Z",
    transform: "translate(1078.682 -214.295)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-4.9,6.8c2-2.716,7.138-2.549,7.138-2.549L76.079,0l8.8,4.9V0H276.853l3.524,4.9L284.928,0l63.286-1.67s5.44-.218,6.456.435,3.2,1.69,2.4,5.912c-2.689,14.273-9.733,49.8-15.833,64.44-1.481,3.557-2.238,3.717-3.558,4.565S331.347,75,331.347,75H269l-13.139-5.922V75H87.386l-6.827-5.922L78.171,75H11.142a6.243,6.243,0,0,1-3.513-.795C6.4,73.262,6.117,70.85,6.117,70.85L-5.744,15.115S-6.9,9.518-4.9,6.8Z",
    transform: "translate(6.075 1.705)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-740.356,282.859l11.787,15.386.378-14.245Z",
    transform: "translate(753.682 -207.295)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleBg);
export default __webpack_public_path__ + "static/media/title-bg.775cf277cf93029778b20f2d0104d4b0.svg";
export { ForwardRef as ReactComponent };